module.exports = __webpack_public_path__ + "img/rafiki.6a524018.png";